import { render, staticRenderFns } from "./WysiwygEditor.vue?vue&type=template&id=b23bc8f2&scoped=true&"
import script from "./WysiwygEditor.vue?vue&type=script&lang=ts&"
export * from "./WysiwygEditor.vue?vue&type=script&lang=ts&"
import style0 from "./WysiwygEditor.vue?vue&type=style&index=0&id=b23bc8f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23bc8f2",
  null
  
)

export default component.exports